<template>
    <div>
        <d-form id="facebookForm" @submit.prevent="updateConnection">
            <div class="form-group">
                <label>Access token</label>
                <d-input required v-model="accessToken" />
            </div>
            <div class="form-group">
                <label>Pixel id</label>
                <d-input required v-model="pixelId" />
            </div>
            <div class="form-group">
                <label>Event</label>
                <p class="text-muted text-sm-left help-text mb-2">We will use the selected Facebook conversion event to send your affiliate transactions generated from your Facebook Ads to your Facebook Ads manager. Need more info? Check our <a href="https://knowledge.ivanhoe.io/en/articles/75105-optimize-your-affiliate-profits-from-your-facebook-ads-account" target="_blank">blogpost</a>!</p>
                <select v-model="eventName" class="form-control">
                    <option :value="eventName" v-for="eventName in eventNames">{{ eventName }}</option>
                </select>
            </div>
            <d-button theme="success" type="submit">Update</d-button>
            <d-button class="btn btn-danger ml-3" @click="disconnect()">Disconnect</d-button>
        </d-form>
    </div>
</template>

<script>
    import { FacebookIntegrationService, ErrorService, WebsiteService } from '@/main';
    import notification from '@/mixins/notification';
    import * as Sentry from "@sentry/browser"
    import EventNames from '@/models/integrations/facebook/eventNames.model.js'

    export default {
        name: "FacebookUpdateConnectionForm",

        props: ['configuration', 'websiteId'],

        mixins: [notification],

        data() {
            return {
                accessToken: '',
                pixelId: '',
                eventName: '',
                eventNames: EventNames,
            }
        },

        methods: {
            async updateConnection() {
                try {
                    await FacebookIntegrationService.connect(
                        this.websiteId,
                        this.accessToken,
                        this.pixelId,
                        this.eventName
                    )

                    this.showNotification('success', 'Alert', 'Facebook successfully updated!')
                    this.$router.go()
                } catch(e) {
                    this.showNotification('error-notification', 'Oops! We have a problem', ErrorService.getErrorMessage(e.networkError.result.errors[0]))
                    console.log(e)
                    Sentry.captureException(e);
                }
            },
            async disconnect() {
                try {
                    await WebsiteService.disconnectIntegration(this.$route.params.id, 'facebook')
                    this.showNotification('success', 'Alert', 'Integration successfully disconnected!')
                    this.$router.go()
                } catch (e) {
                    this.showNotification('error-notification', 'Oops! We have a problem', ErrorService.getErrorMessage(e.networkError.result.errors[0]))
                    console.log(e)
                    Sentry.captureException(e);
                }
            }
        },

        created() {
            this.accessToken = this.configuration.access_token
            this.pixelId = this.configuration.pixel_id
            this.eventName = this.configuration.event_name
        },
    }
</script>
